import React, { useEffect } from "react";

const ResumeTable = ({ data }) => {
  const [referenceData, setReferenceData] = React.useState([]);
  const [dataValues, setDataValues] = React.useState([]);
  const haveUsableReference = data.reference.usableReferenceData;

  useEffect(() => {
    const getValues = () => {
      setReferenceData([]);
      setDataValues([]);
      const columnValues = [];
      for (let i = 1; i < data.header.length; i++) {
        const column = [data.header[i]];
        for (let j = 0; j < data.values.length; j++) {
          column.push(data.values[j][i]);
        }
        columnValues.push(column);
      }
      if (haveUsableReference) {
        setReferenceData(columnValues[columnValues.length - 1]);
        setDataValues(columnValues.slice(0, columnValues.length - 1));
      } else {
        setDataValues(columnValues);
      }
    };

    if (data) {
      getValues();
    }
  }, [data, haveUsableReference]);

  if (!data || !data.values || !data.header) {
    return <div>Dados não disponíveis</div>;
  }

  const { title, values } = data;

  const renderHeader = () => {
    return (
      <tr className="text-gray-800 bg-gray-100 w-full ">
        <th className="font-normal px-4 py-2 text-justify text-xs">{title}</th>
        {values.map((value, index) => (
          <th key={index} className="font-normal text-left text-xs px-4">{value[0]}</th>
        ))}
        <th className="text-justify font-semibold text-xs">Total</th>
      </tr>
    );
  };

  const renderColumns = () => {
    return dataValues.map((column, index) => (
      <tr key={index} className="border ">
        <td className="px-4 py-2 text-sm font-medium text-gray-700">{column[0]}</td>
        {column.slice(1).map((percentage, idx) => (
          <td key={idx} className="text-gray-500 text-sm font-normal px-4">{percentage} %</td>
        ))}
        <td className="font-normal text-sm text-gray-700">{calculateColumnTotal(column.slice(1)).toFixed(1)} %</td>
      </tr>
    ));
  };

  const calculateColumnTotal = (columnValues) => {
    return columnValues.reduce((acc, curr) => acc + parseFloat(curr), 0);
  };

  const calculateRowTotals = () => {
    const totals = new Array(values.length).fill(0);
    values.forEach((value, index) => {
      if (haveUsableReference) {
        value = value.slice(0, value.length - 1)
      }
      value.slice(1).forEach((percentage) => {
        totals[index] += parseFloat(percentage);
      });
    });
    return totals;
  };

  const renderReference = () => {
    return (
      <tr className="border">
        <td className="py-2 px-4 text-sm font-medium text-blue-table">{referenceData[0]}</td>
        {referenceData.slice(1).map((total, index) => (
          <td key={index} className="text-sm font-medium text-blue-table just px-4">{total} %</td>
        ))}
        {referenceData !== false && <td className="text-sm font-normal text-gray-600">
          {calculateColumnTotal(referenceData.slice(1)).toFixed(1)} %
        </td>}
      </tr>
    );
  };

  const renderRowTotals = () => {
    const totals = calculateRowTotals();

    return (
      <tr className="border">
        <td className="font-semibold p-4 text-blue-table bg-gray-50">Total</td>
        {totals.map((total, index) => (
          <td key={index} className="font-semibold dark-primary text-sm px-4 bg-gray-50">{total.toFixed(1)} %</td>
        ))}
        <td className="dark-primary font-semibold text-sm bg-gray-50">{calculateGrandTotal().toFixed(1)} %</td>
      </tr>
    );
  };

  const calculateGrandTotal = () => {
    let grandTotal = 0;
    values.forEach((value) => {
      if (haveUsableReference) {
        value = value.slice(0, value.length - 1)
      }
      value.slice(1).forEach((percentage) => {
        grandTotal += parseFloat(percentage);
      });
    });

    return grandTotal;
  };

  return (
    <table className="table-auto shadow-lg select-none w-full">
      <thead>{renderHeader()}</thead>
      <tbody>
      {renderColumns()}
      {renderRowTotals()}
      {haveUsableReference && renderReference()}
      </tbody>
    </table>
  );
};

export default ResumeTable;
